import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { text, colors, mixins } from '../../core/styles/theme/default';

const StyledTags = styled.ul`
  ${mixins.listReset};
  display: flex;
  flex-flow: row wrap;
  gap: ${rem(4)};
`;

const StyledTag = styled.a<any>`
  ${text.p4}
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${rem(4)} ${rem(16)};
  text-decoration: none;
  background: ${colors.primary};
  color: ${colors.white};
  border-radius: ${rem(20)};
`;

const Tags = ({ tags }: TagsProps) => {
  return (
    <StyledTags>
      {tags.map(
        (
          tag: {
            information_hub: { slug: string }[];
            title: string;
            as: string;
          },
          index: number,
        ) => {
          return (
            <li key={index}>
              <StyledTag
                key={index}
                href={tag.information_hub ? `/information-hub/` : undefined}
                as={typeof tag.as !== undefined ? tag.as : false}
              >
                {tag.title}
              </StyledTag>
            </li>
          );
        },
      )}
    </StyledTags>
  );
};

export type TagsProps = {
  /** tags to render */
  tags: any;
};

export default Tags;
